import { render, staticRenderFns } from "./fclExtraForm.vue?vue&type=template&id=ab68be6a&"
import script from "./fclExtraForm.vue?vue&type=script&lang=js&"
export * from "./fclExtraForm.vue?vue&type=script&lang=js&"
import style0 from "./fclExtraForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab68be6a')) {
      api.createRecord('ab68be6a', component.options)
    } else {
      api.reload('ab68be6a', component.options)
    }
    module.hot.accept("./fclExtraForm.vue?vue&type=template&id=ab68be6a&", function () {
      api.rerender('ab68be6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceFCLExtra/components/fclExtraForm.vue"
export default component.exports